// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Inventory status background colors */
.green-row {
  background-color: #c8e6c9 !important; /* Light green for inventoryStatus column */
}

.yellow-row {
  background-color: #fff9c4 !important; /* Light yellow for inventoryStatus column */
}

.red-row {
  background-color: #f8d7da !important; /* Light red for inventoryStatus column */
}

/* New style for availableVendor < 2 */
.orange-row {
  background-color: #ffe0b2 !important; /* Light orange for availableVendor < 2 */
}

/* Special case: highlight the entire row in red if inventoryStatus is 'RED' and orderDetail is empty */
.red-row-highlight {
  background-color: #f8d7da !important; /* Light red for the whole row */
}

.vendor-row .MuiDataGrid-cell {
  padding-left: 40px; /* Indent vendor rows */
  background-color: #f9f9f9; /* Optional: lighter background */
}

.vendor-details-box {
  background-color: #f5f5f5; /* Light grey background */
  margin: 0; /* Remove margin for full-width alignment */
  padding: 16px 24px; /* Adjust padding for consistency */
  border-radius: 0; /* Remove rounded corners for full-width appearance */
  width: 100%; /* Ensure it spans the entire main table row */
}

.vendor-details-box table {
  width: 100%; /* Ensure the table fills the box */
}

.vendor-details-box .MuiTableCell-root:first-child {
  visibility: hidden; /* Hide first cell to shift Vendor Name under Quantity */
}

.vendor-details-box .MuiTableCell-root:nth-child(2) {
  text-align: left; /* Align "Vendor Name" properly under Quantity */
}

.table-container {
  max-height: 600px;
  overflow-y: auto;
}

.table-container::-webkit-scrollbar {
  width: 8px;
}

.table-container::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
`, "",{"version":3,"sources":["webpack://./src/inventory/components/InventoryReport.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,oCAAoC,EAAE,2CAA2C;AACnF;;AAEA;EACE,oCAAoC,EAAE,4CAA4C;AACpF;;AAEA;EACE,oCAAoC,EAAE,yCAAyC;AACjF;;AAEA,sCAAsC;AACtC;EACE,oCAAoC,EAAE,yCAAyC;AACjF;;AAEA,uGAAuG;AACvG;EACE,oCAAoC,EAAE,gCAAgC;AACxE;;AAEA;EACE,kBAAkB,EAAE,uBAAuB;EAC3C,yBAAyB,EAAE,iCAAiC;AAC9D;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,SAAS,EAAE,2CAA2C;EACtD,kBAAkB,EAAE,mCAAmC;EACvD,gBAAgB,EAAE,qDAAqD;EACvE,WAAW,EAAE,8CAA8C;AAC7D;;AAEA;EACE,WAAW,EAAE,mCAAmC;AAClD;;AAEA;EACE,kBAAkB,EAAE,wDAAwD;AAC9E;;AAEA;EACE,gBAAgB,EAAE,gDAAgD;AACpE;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* Inventory status background colors */\n.green-row {\n  background-color: #c8e6c9 !important; /* Light green for inventoryStatus column */\n}\n\n.yellow-row {\n  background-color: #fff9c4 !important; /* Light yellow for inventoryStatus column */\n}\n\n.red-row {\n  background-color: #f8d7da !important; /* Light red for inventoryStatus column */\n}\n\n/* New style for availableVendor < 2 */\n.orange-row {\n  background-color: #ffe0b2 !important; /* Light orange for availableVendor < 2 */\n}\n\n/* Special case: highlight the entire row in red if inventoryStatus is 'RED' and orderDetail is empty */\n.red-row-highlight {\n  background-color: #f8d7da !important; /* Light red for the whole row */\n}\n\n.vendor-row .MuiDataGrid-cell {\n  padding-left: 40px; /* Indent vendor rows */\n  background-color: #f9f9f9; /* Optional: lighter background */\n}\n\n.vendor-details-box {\n  background-color: #f5f5f5; /* Light grey background */\n  margin: 0; /* Remove margin for full-width alignment */\n  padding: 16px 24px; /* Adjust padding for consistency */\n  border-radius: 0; /* Remove rounded corners for full-width appearance */\n  width: 100%; /* Ensure it spans the entire main table row */\n}\n\n.vendor-details-box table {\n  width: 100%; /* Ensure the table fills the box */\n}\n\n.vendor-details-box .MuiTableCell-root:first-child {\n  visibility: hidden; /* Hide first cell to shift Vendor Name under Quantity */\n}\n\n.vendor-details-box .MuiTableCell-root:nth-child(2) {\n  text-align: left; /* Align \"Vendor Name\" properly under Quantity */\n}\n\n.table-container {\n  max-height: 600px;\n  overflow-y: auto;\n}\n\n.table-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.table-container::-webkit-scrollbar-thumb {\n  background-color: #888;\n  border-radius: 4px;\n}\n\n.table-container::-webkit-scrollbar-thumb:hover {\n  background-color: #555;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
